import React, { useState } from "react";
import {
  PageHeader,
  Form,
  Input,
  Col,
  Row,
  Card,
  Button,
  Divider,
  Space,
  message,
  notification,
  Popconfirm,
} from "antd";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/lib/form/Form";
import StokBirimSelectOption from "../components/toolbox/StokBirimSelectOption";
import StokKategoriSelectOption from "../components/toolbox/StokKategoriSelectOption";
import StokVaryantSelectOption from "../components/toolbox/StokVaryantSelectOption";
import {
  PlusOutlined,
  SaveFilled,
  DeleteOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import CurrencyInput, {
  setFieldsAutoClear,
} from "../components/toolbox/CurrencyInput";
import DovizSelectOption from "../components/toolbox/DovizSelectOption";
import useVarsayilanDeger from "../hooks/useVarsayilanDeger";
import { yuzdeHesala } from "../helpers/HesaplamaHelper";
import strings from "../utils/Localization";
import useApi from "../hooks/useApi";

function VaryantliStokEkle() {
  const [form] = useForm();
  const navigate= useNavigate();
  const { getDefaultSetting } = useVarsayilanDeger();
  const [fetchLoading, setFetchLoading] = useState(false);
  const api = useApi();
  const { varyantliStokEkle: localization } = strings;

  const onFinish = async (values) => {
    try {
      const {
        urunAdi,
        stokBirimId,
        stokKategoriId,
        aciklama,
        varyantGrup = [],
      } = values;

      if (varyantGrup.length === 0) {
        return message.warning("Lütfen varyant oluşturunuz");
      }

      let varyantGrupData = [];
      varyantGrup.map((item) => {
        return varyantGrupData.push({
          Barkod: item.barkod,
          Aciklama: item.aciklama,
          Kod: item.kod,
          Gtin: item.gtin,
          Raf: item.raf,
          ResimUrl: "",
          resimAd: new Date().valueOf(),
          StokvaryantgrupHasStokvaryantdeger: Array.isArray(item.varyant)
            ? item.varyant.map((varyantItem) => {
                return { StokVaryantDegerId: varyantItem.Id };
              })
            : [{ StokVaryantDegerId: item.varyant.Id }],
          Stokvaryantgrupfiyat: [
            {
              DovizId: item.satisDovizId,
              OtvTutar: item.satisOtvTutar,
              OtvOran: item.satisOtvOran,
              KdvTutar: item.satisKdvTutar,
              KdvOran: item.satisKdvOran,
              Fiyat: item.vergilerHaricSatisFiyat,
              GenelToplam: item.vergilerDahilSatisFiyat,
              SatisMi: 1,
            },
            {
              DovizId: item.alisDovizId,
              OtvTutar: item.alisOtvTutar,
              OtvOran: item.alisOtvOran,
              KdvTutar: item.alisKdvTutar,
              KdvOran: item.alisKdvOran,
              Fiyat: item.vergilerHaricAlisFiyat,
              GenelToplam: item.vergilerDahilAlisFiyat,
              SatisMi: 0,
            },
          ],
        });
      });
      setFetchLoading(true);
      const response = await api.post("/stok", {
        StokKategoriId: stokKategoriId,
        StokBirimId: stokBirimId,
        ad: urunAdi,
        aciklama: aciklama,
        Stokvaryantgrup: varyantGrupData,
      });

      if (response.status === 200) {
        notification["success"]({
          description: strings.mesaj.islemBasarili,
          message: strings.mesaj.basarliBaslik,
        });
        form.resetFields();
        form.setFieldsValue({ varyantGrup: [] });
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  const createVaryant = () => {
    const { selectStokVaryant } = form.getFieldValue();
    const jsonData = selectStokVaryant.map((item) => {
      return JSON.parse(item);
    });

    const seciliVaryantIdArray = jsonData
      .map((item) => item.StokVaryantId)
      .filter((v, i, a) => a.indexOf(v) === i);

    let varyantGrupArray = [];
    seciliVaryantIdArray.map((seciliVaryantId) => {
      let data = [];
      jsonData
        .filter((x) => x.StokVaryantId === seciliVaryantId)
        .map((i) => {
          return data.push(i);
        });
      return varyantGrupArray.push(data);
    });

    var result = varyantGrupArray.reduce((a, b) =>
      a.reduce((r, v) => r.concat(b.map((w) => [].concat(v, w))), [])
    );

    form.setFields([
      {
        name: "varyantGrup",
        value: result.map((item) => ({
          baslik: Array.isArray(item) ? item.map((i) => i.Ad + " - ") : item.Ad,
          varyant: item,
          barkod: "",
          gtin: "",
          kod: "",
          raf: "",
          aciklama: "",
          vergilerHaricAlisFiyat: 0,
          alisDovizId: String(getDefaultSetting("doviz")),
          alisKdvOran: 0,
          alisKdvTutar: 0,
          alisOtvOran: 0,
          alisOtvTutar: 0,
          vergilerDahilAlisFiyat: 0,
          vergilerHaricSatisFiyat: 0,
          satisDovizId: String(getDefaultSetting("doviz")),
          satisKdvOran: 0,
          satisKdvTutar: 0,
          satisOtvOran: 0,
          satisOtvTutar: 0,
          vergilerDahilSatisFiyat: 0,
        })),
      },
    ]);
  };

  const satisFiyatHesaplama = (item, name) => {
    const { varyantGrup } = form.getFieldsValue();
    const {
      vergilerHaricSatisFiyat,
      satisKdvOran,
      satisOtvOran,
      vergilerDahilSatisFiyat,
    } = varyantGrup[name];

    let yeniVergilerHaricSatisFiyat = vergilerHaricSatisFiyat;
    if (item === `vergilerDahilSatisFiyat`) {
      yeniVergilerHaricSatisFiyat = parseFloat(
        vergilerDahilSatisFiyat /
          (satisKdvOran / 100 + 1) /
          (satisOtvOran / 100 + 1)
      ).toFixed(2);
    }
    const otvTutar = yuzdeHesala(satisOtvOran, yeniVergilerHaricSatisFiyat);
    const otvliTutar = parseFloat(yeniVergilerHaricSatisFiyat) + otvTutar;
    const kdvTutar = yuzdeHesala(otvliTutar, satisKdvOran);

    form.setFields([
      {
        name: ["varyantGrup", name, "satisKdvTutar"],
        value: kdvTutar,
      },
      {
        name: ["varyantGrup", name, "satisOtvTutar"],
        value: otvTutar,
      },
    ]);

    if (item === `vergilerHaricSatisFiyat`) {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        {
          name: ["varyantGrup", name, "vergilerDahilSatisFiyat"],
          value: vergiDahilFiyat,
        },
      ]);
    } else if (item === `vergilerDahilSatisFiyat`) {
      const vergiHaricFiyat = parseFloat(
        vergilerDahilSatisFiyat /
          (satisKdvOran / 100 + 1) /
          (satisOtvOran / 100 + 1)
      ).toFixed(2);
      form.setFields([
        {
          name: ["varyantGrup", name, "vergilerHaricSatisFiyat"],
          value: vergiHaricFiyat,
        },
      ]);
    } else {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        {
          name: ["varyantGrup", name, "vergilerDahilSatisFiyat"],
          value: vergiDahilFiyat,
        },
      ]);
    }
  };

  const alisFiyatHesaplama = (item, name) => {
    const { varyantGrup } = form.getFieldsValue();
    const {
      vergilerHaricAlisFiyat,
      alisKdvOran,
      alisOtvOran,
      vergilerDahilAlisFiyat,
    } = varyantGrup[name];

    let yeniVergilerHaricAlisFiyat = vergilerHaricAlisFiyat;
    if (item === `vergilerDahilAlisFiyat`) {
      yeniVergilerHaricAlisFiyat = parseFloat(
        vergilerDahilAlisFiyat /
          (alisKdvOran / 100 + 1) /
          (alisOtvOran / 100 + 1)
      ).toFixed(2);
    }
    const otvTutar = yuzdeHesala(alisOtvOran, yeniVergilerHaricAlisFiyat);
    const otvliTutar = parseFloat(yeniVergilerHaricAlisFiyat) + otvTutar;
    const kdvTutar = yuzdeHesala(otvliTutar, alisKdvOran);

    form.setFields([
      {
        name: ["varyantGrup", name, "alisKdvTutar"],
        value: kdvTutar,
      },
      {
        name: ["varyantGrup", name, "alisOtvTutar"],
        value: otvTutar,
      },
    ]);

    if (item === `vergilerHaricAlisFiyat`) {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        {
          name: ["varyantGrup", name, "vergilerDahilAlisFiyat"],
          value: vergiDahilFiyat,
        },
      ]);
    } else if (item === `vergilerDahilAlisFiyat`) {
      const vergiHaricFiyat = parseFloat(
        vergilerDahilAlisFiyat /
          (alisKdvOran / 100 + 1) /
          (alisOtvOran / 100 + 1)
      ).toFixed(2);
      form.setFields([
        {
          name: ["varyantGrup", name, "vergilerHaricAlisFiyat"],
          value: vergiHaricFiyat,
        },
      ]);
    } else {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        {
          name: ["varyantGrup", name, "vergilerDahilAlisFiyat"],
          value: vergiDahilFiyat,
        },
      ]);
    }
  };

  const varyantGrupIcerikKopyala = (name) => {
    const currentVaryantGrupArray = form.getFieldValue("varyantGrup");
    const selectedVaryantGrup = form.getFieldValue("varyantGrup")[name];

    let nextVaryantGrupArray = [];
    currentVaryantGrupArray.map((item) => {
     return nextVaryantGrupArray.push({
        ...selectedVaryantGrup,
        baslik: item.baslik,
        varyant: item.varyant,
      });
    });

    form.setFields([{ name: "varyantGrup", value: nextVaryantGrupArray }]);
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        onBack={() => navigate(-1)}
        title={localization.baslik}
        ghost={false}
        extra={
          <Button
            type="primary"
            form="varyantliStokEkleForm"
            icon={<SaveFilled />}
            size="large"
            htmlType="submit"
            loading={fetchLoading}
          >
            {localization.kaydetButton}
          </Button>
        }
      />
      <Form
        form={form}
        onFinish={onFinish}
        size="middle"
        layout="vertical"
        id="varyantliStokEkleForm"
      >
        <Space size="large" style={{ width: "100%" }} direction="vertical">
          <Card>
            <Row gutter={24}>
              <Col flex={2}>
                <Form.Item
                  label={localization.urunAdi}
                  name="urunAdi"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col flex={1}>
                <Form.Item
                  name="stokBirimId"
                  label={strings.stokBirimSelectOption.stokBirimBaslik}
                  rules={[{ required: true }]}
                >
                  <StokBirimSelectOption />
                </Form.Item>
              </Col>
              <Col flex={1}>
                <Form.Item
                  name="stokKategoriId"
                  label={strings.stokKategoriSelectOption.stokKategoriBaslik}
                  rules={[{ required: true }]}
                >
                  <StokKategoriSelectOption />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item label={localization.aciklama} name="aciklama">
              <Input.TextArea rows={3} />
            </Form.Item>
          </Card>
          <Card>
            <Row>
              <div style={{ flex: 1 }}>
                <Form.Item
                  name="selectStokVaryant"
                  label={localization.stokVaryantlari}
                  rules={[{ required: true }]}
                >
                  <StokVaryantSelectOption />
                </Form.Item>
              </div>
              <Form.Item
                label=" "
                shouldUpdate={(prevValues, currentValues) =>
                  prevValues.selectStokVaryant !==
                  currentValues.selectStokVaryant
                }
              >
                {({ getFieldValue }) => {
                  const currentSelectStokVaryant =
                    getFieldValue("selectStokVaryant");
                  let disabled = true;
                  if (currentSelectStokVaryant !== undefined) {
                    if (currentSelectStokVaryant.length > 0) disabled = false;
                  }
                  return (
                    <Button
                      icon={<PlusOutlined />}
                      type="primary"
                      onClick={createVaryant}
                      disabled={disabled}
                    >
                      {localization.varyantOlusturButton}
                    </Button>
                  );
                }}
              </Form.Item>
            </Row>
          </Card>
          <Form.List name="varyantGrup">
            {(fields, { add, remove }) => (
              <Space
                direction="vertical"
                style={{ width: "100%" }}
                size="large"
              >
                {fields.map(({ key, name, fieldKey }, index) => {
                  const { varyantGrup } = form.getFieldValue();
                  return (
                    <Card
                      title={varyantGrup[name].baslik}
                      extra={
                        <Space>
                          {index === 0 && (
                            <Popconfirm
                              title={localization.varyantGrupKopyala(varyantGrup[name].baslik)}
                              onConfirm={() => varyantGrupIcerikKopyala(name)}
                            >
                              <Button icon={<CopyOutlined />}/>
                              
                            </Popconfirm>
                          )}
                          <Button
                            onClick={() => remove(name)}
                            icon={<DeleteOutlined />}
                          />
                        </Space>
                      }
                    >
                      <Row gutter={12}>
                        <Col flex={1}>
                          <Form.Item
                            name={[name, "barkod"]}
                            label={localization.varyantGrup.barkod}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col flex={1}>
                          <Form.Item
                            name={[name, "gtin"]}
                            label={localization.varyantGrup.gtin}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col flex={1}>
                          <Form.Item
                            name={[name, "kod"]}
                            label={localization.varyantGrup.kod}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col flex={1}>
                          <Form.Item
                            name={[name, "raf"]}
                            label={localization.varyantGrup.raf}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item
                        name={[name, "aciklama"]}
                        label={localization.varyantGrup.aciklama}
                      >
                        <Input.TextArea rows={3} />
                      </Form.Item>
                      <Divider />
                      <Row gutter={24}>
                        <Col flex={1}>
                          <Form.Item
                            name={[name, "vergilerHaricAlisFiyat"]}
                            label={
                              localization.varyantGrup.stokAlisFiyati
                                .vergilerHaricAlisFiyati
                            }
                            rules={[{ required: true }]}
                          >
                            <CurrencyInput
                              addonAfter={
                                <Form.Item
                                  name={[name, "alisDovizId"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: strings.mesaj.gerekliBirAlan,
                                    },
                                  ]}
                                  noStyle
                                >
                                  <DovizSelectOption showKod />
                                </Form.Item>
                              }
                              onChange={() =>
                                alisFiyatHesaplama(
                                  "vergilerHaricAlisFiyat",
                                  name
                                )
                              }
                              {...setFieldsAutoClear(form, [
                                "varyantGrup",
                                name,
                                "vergilerHaricAlisFiyat",
                              ])}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, "alisOtvOran"]}
                            label={
                              localization.varyantGrup.stokAlisFiyati
                                .alisOtvOran
                            }
                            rules={[{ required: true }]}
                          >
                            <CurrencyInput
                              onChange={() =>
                                alisFiyatHesaplama("alisOtvOran", name)
                              }
                              {...setFieldsAutoClear(form, [
                                "varyantGrup",
                                name,
                                "alisOtvOran",
                              ])}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, "alisKdvOran"]}
                            label={
                              localization.varyantGrup.stokAlisFiyati
                                .alisKdvOran
                            }
                            rules={[{ required: true }]}
                          >
                            <CurrencyInput
                              onChange={() =>
                                alisFiyatHesaplama("alisKdvOran", name)
                              }
                              {...setFieldsAutoClear(form, [
                                "varyantGrup",
                                name,
                                "alisKdvOran",
                              ])}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, "vergilerDahilAlisFiyat"]}
                            label={
                              localization.varyantGrup.stokAlisFiyati
                                .vergilerDahilAlisFiyati
                            }
                            rules={[{ required: true }]}
                          >
                            <CurrencyInput
                              addonAfter={
                                <Form.Item
                                  name={[name, "alisDovizId"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: strings.mesaj.gerekliBirAlan,
                                    },
                                  ]}
                                  noStyle
                                >
                                  <DovizSelectOption showKod />
                                </Form.Item>
                              }
                              onChange={() =>
                                alisFiyatHesaplama(
                                  "vergilerDahilAlisFiyat",
                                  name
                                )
                              }
                              {...setFieldsAutoClear(form, [
                                "varyantGrup",
                                name,
                                "vergilerDahilAlisFiyat",
                              ])}
                            />
                          </Form.Item>
                        </Col>
                        <Col flex={1}>
                          <Form.Item
                            name={[name, "vergilerHaricSatisFiyat"]}
                            label={
                              localization.varyantGrup.stokSatisFiyati
                                .vergilerHaricSatisFiyati
                            }
                            rules={[{ required: true }]}
                          >
                            <CurrencyInput
                              addonAfter={
                                <Form.Item
                                  name={[name, "satisDovizId"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: strings.mesaj.gerekliBirAlan,
                                    },
                                  ]}
                                  noStyle
                                >
                                  <DovizSelectOption showKod />
                                </Form.Item>
                              }
                              onChange={() =>
                                satisFiyatHesaplama(
                                  "vergilerHaricSatisFiyat",
                                  name
                                )
                              }
                              {...setFieldsAutoClear(form, [
                                "varyantGrup",
                                name,
                                "vergilerHaricSatisFiyat",
                              ])}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, "satisOtvOran"]}
                            label={
                              localization.varyantGrup.stokSatisFiyati
                                .satisOtvOran
                            }
                            rules={[{ required: true }]}
                          >
                            <CurrencyInput
                              onChange={() =>
                                satisFiyatHesaplama("satisOtvOran", name)
                              }
                              {...setFieldsAutoClear(form, [
                                "varyantGrup",
                                name,
                                "satisOtvOran",
                              ])}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, "satisKdvOran"]}
                            label={
                              localization.varyantGrup.stokSatisFiyati
                                .satisKdvOran
                            }
                            rules={[{ required: true }]}
                          >
                            <CurrencyInput
                              onChange={() =>
                                satisFiyatHesaplama("satisKdvOran", name)
                              }
                              {...setFieldsAutoClear(form, [
                                "varyantGrup",
                                name,
                                "satisKdvOran",
                              ])}
                            />
                          </Form.Item>
                          <Form.Item
                            name={[name, "vergilerDahilSatisFiyat"]}
                            label={
                              localization.varyantGrup.stokSatisFiyati
                                .vergilerDahilSatisFiyati
                            }
                            rules={[{ required: true }]}
                          >
                            <CurrencyInput
                              addonAfter={
                                <Form.Item
                                  name={[name, "satisDovizId"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: strings.mesaj.gerekliBirAlan,
                                    },
                                  ]}
                                  noStyle
                                >
                                  <DovizSelectOption showKod />
                                </Form.Item>
                              }
                              onChange={() =>
                                satisFiyatHesaplama(
                                  "vergilerDahilSatisFiyat",
                                  name
                                )
                              }
                              {...setFieldsAutoClear(form, [
                                "varyantGrup",
                                name,
                                "vergilerDahilSatisFiyat",
                              ])}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  );
                })}
              </Space>
            )}
          </Form.List>
        </Space>
      </Form>
      <br />
    </Space>
  );
}

export default VaryantliStokEkle;
